/**
 * OKS-905 — shared "—" placeholder for admin serialiser association refs
 * whose display name can degrade to `null`.
 *
 * Several admin serialisers guard an unconditionally-dereferenced preloaded
 * association (e.g. `m.brand&.name`, `assignment.agency&.name`) so a
 * concurrently-deleted parent degrades gracefully instead of raising
 * `NoMethodError` → a full-page 500 (the OKS-900 class). When guarded, the
 * wire carries `name: null` (the FK id is retained). Rendering
 * `nameOrDash(name)` keeps the row visible with a legible, screen-reader
 * friendly em-dash rather than a blank cell (UX Spec §2/§3, PRD §3).
 *
 * Defense-in-depth: the load-bearing fix is `eager_load` (single snapshot),
 * which makes the null structurally unreachable for the current cascade FKs
 * (parent + child die atomically). This placeholder covers any residual /
 * future non-cascade tear. See TRD-OKS-905 KD-1/KD-2.
 */
export const ADMIN_NAME_PLACEHOLDER = "—"

/** Returns the name, or the em-dash placeholder when it is null/undefined. */
export function nameOrDash(name: string | null | undefined): string {
  return name ?? ADMIN_NAME_PLACEHOLDER
}
